/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from 'react'
import debounce from "lodash.debounce";
import { Card, CardBody, Col, Container, Input, Label, Row, Button, UncontrolledTooltip, Dropdown, DropdownToggle, DropdownMenu, Spinner } from 'reactstrap'
import DataTable from 'react-data-table-component'
import { FiExternalLink } from "react-icons/fi";
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import dayjs from 'dayjs';

import Breadcrumbs from '../../CommonElements/Breadcrumbs'
import BrandExpandedTableRow from '../../Components/Brands/BrandExpandedTableRow'
import { connect } from 'react-redux';
import { assignBrandToCompany as assignBrandToCompanyAction, getAllBrands as getAllBrandsAction, getCompanies as getCompaniesAction, deleteBrands as deleteBrandsAction, getFilters as getFiltersAction, setSelectedFilters as setSelectedFiltersAction, refetch as refetchAction, exportBrands as exportBrandsAction } from '../../ReduxToolkit/Reducers/brands';
import FilterDrawer from '../../CommonElements/FilterDrawer';
import { Link, useNavigate } from 'react-router-dom';
import { Trash, Eye, Edit, Globe, Calendar, ChevronDown, X, Search, Download } from 'react-feather';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import CompaniesDrawer from '../../Components/CompaniesDrawer';
import AddManuallyModal from '../../Components/AddManuallyModal';
import BulkAddToProfileModal from '../../Components/BulkAddToProfileModal';
import BrandsDetailsDrawer from '../../Components/Brands/BrandDetailsDrawer';
import ConfirmationModal from '../../Components/ConfirmationModal';
import EditEntityNameModal from '../../Components/EditEntityNameModal';
import SpecificBrandsSearchModal from '../../Components/Brands/SpecificBrandsSearchModal';
import { getCamelCaseWord } from '../../static/brands_wholesalers_data';

function Brands({ getAllBrands, allBrands, totalBrands, filtersData, getFilters, selectedFilters, setSelectedFilters, assignBrandToCompany, getCompanies, deleteBrands, refetch, exportBrands }) {
  const navigate = useNavigate();
  const [page, setPage] = useState(selectedFilters?.page || 1);
  const [confirmationModal, setConfirmationModal] = useState(false)
  const [signleDeleteBrand, setSignleDeleteBrand] = useState(false)
  const [deleteLoading, setDeleteLoading] = useState(false)
  const [isDrawerOpen, setIsDrawerOpen] = useState(false)
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [tableData, setTableData] = useState(allBrands[page] || []);
  const [searchText, setSearchText] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterLoading, setFilterLoading] = useState(false);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedRowsData, setSelectedRowsData] = useState(false);
  const [manuallyModal, setManuallModal] = useState(false);
  // 'matches' | 'next_to' while the bulk add modal is open
  const [bulkAddAction, setBulkAddAction] = useState(null);
  const [editNameModal, setEditNameModal] = useState(null);
  const [selectedFilter, setSelectedFilter] = useState(selectedFilters?.filters || {});
  const [createdDateRange, setCreatedDateRange] = useState({ startDate: null, endDate: null });
  const [updatedDateRange, setUpdatedDateRange] = useState({ startDate: null, endDate: null });
  const [createdDatePickerOpen, setCreatedDatePickerOpen] = useState(false);
  const [updatedDatePickerOpen, setUpdatedDatePickerOpen] = useState(false);
  const [specificBrandsSearches, setSpecificBrandsSearches] = useState([]);
  const [specificBrandsModalOpen, setSpecificBrandsModalOpen] = useState(false);
  const companies = useSelector(state => state.brands?.companies)

  useEffect(() => {
    getCompanies();
    _getFilters();
  }, []);

  useEffect(() => {
    if (page) {
      // if (allBrands[page] && allBrands[page]?.length === itemsPerPage) {
      //   setTableData(allBrands[page]);
      //   setIsLoading(false);
      // } else {
      _getTableData();
      // }
    }
  }, [page]);

  useEffect(() => {
    if (allBrands[page]) {
      setTableData(allBrands[page]);
    }
  }, [allBrands]);

  useEffect(() => {
    _getTableData();
  }, [selectedFilter, itemsPerPage, searchText]);

  useEffect(() => {
    if ((tableData?.length > 0 && tableData?.length !== 10) || itemsPerPage !== 10) {
      _getTableData();
    }
  }, [itemsPerPage]);

  const _getTableData = async (hideLoader = false, createdRange = createdDateRange, updatedRange = updatedDateRange, specificBrands = specificBrandsSearches) => {
    if (!hideLoader) setIsLoading(true);
    await getAllBrands(
      page,
      selectedFilter,
      searchText,
      itemsPerPage,
      null,
      null,
      createdRange?.startDate ? createdRange : null,
      updatedRange?.startDate ? updatedRange : null,
      specificBrands?.length > 0 ? specificBrands : null
    );
    setIsLoading(false);
  };

  // Same arguments as _getTableData, minus pagination: the export gets every matching row.
  const [exportLoading, setExportLoading] = useState(false);
  const handleExport = async () => {
    setExportLoading(true);
    await exportBrands(
      selectedFilter,
      searchText,
      createdDateRange?.startDate ? createdDateRange : null,
      updatedDateRange?.startDate ? updatedDateRange : null,
      specificBrandsSearches?.length > 0 ? specificBrandsSearches : null
    );
    setExportLoading(false);
  };

  const _getFilters = async () => {
    setFilterLoading(true);
    await getFilters();
    setFilterLoading(false);
  };

  const _searchBrands = (inputValue) => {
    const query = inputValue?.trim();
    setPage(1);
    setSearchText(query);
  };

  const debounceFn = useCallback(debounce(_searchBrands, 1000), []);

  const _handleSearchTextChange = (e) => {
    setSearchTerm(e.target.value);
    debounceFn(e.target.value);
  };

  const handleCopyId = async (id, e) => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(String(id));
      toast.success(`ID ${id} copied`);
    } catch {
      toast.error('Failed to copy ID');
    }
  };

  const handleCreatedDateChange = (dates) => {
    const [start, end] = dates
    const formatStartDate = (date) => {
      if (!date) return null
      // Start of day in local time → converted to UTC ISO string
      return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0).toISOString()
    }
    const formatEndDate = (date) => {
      if (!date) return null
      // End of day in local time → converted to UTC ISO string
      return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 999).toISOString()
    }
    const newDateRange = {
      startDate: formatStartDate(start),
      endDate: formatEndDate(end)
    }
    setCreatedDateRange(newDateRange);
    if (end) {
      setCreatedDatePickerOpen(false);
      setPage(1);
      _getTableData(false, newDateRange, updatedDateRange, specificBrandsSearches);
    }
  };

  const handleUpdatedDateChange = (dates) => {
    const [start, end] = dates
    const formatStartDate = (date) => {
      if (!date) return null
      return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0).toISOString()
    }
    const formatEndDate = (date) => {
      if (!date) return null
      return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 999).toISOString()
    }
    const newDateRange = {
      startDate: formatStartDate(start),
      endDate: formatEndDate(end)
    }
    setUpdatedDateRange(newDateRange);
    if (end) {
      setUpdatedDatePickerOpen(false);
      setPage(1);
      _getTableData(false, createdDateRange, newDateRange, specificBrandsSearches);
    }
  };

  const formatDateRange = (dateRange, label) => {
    if (!dateRange?.startDate && !dateRange?.endDate) return label;
    const start = dateRange?.startDate ? dayjs(dateRange.startDate).format("L") : '';
    const end = dateRange?.endDate ? dayjs(dateRange.endDate).format("L") : '';
    if (start && end) return `${start} - ${end}`;
    if (start) return `From ${start}`;
    return label;
  };

  const handleResetDateFilters = () => {
    setCreatedDateRange({ startDate: null, endDate: null });
    setUpdatedDateRange({ startDate: null, endDate: null });
    setPage(1);
    _getTableData(false, { startDate: null, endDate: null }, { startDate: null, endDate: null }, specificBrandsSearches);
  };

  const handleSpecificBrandsSearch = (names) => {
    setSpecificBrandsSearches(names);
    setPage(1);
    _getTableData(false, createdDateRange, updatedDateRange, names);
  };

  const _handleItemPerPageSelect = async (count) => {
    setPage(1);
    setItemsPerPage(count);
  };

  const _handleFilterApply = (_filters) => {
    setPage(1);
    setSelectedFilters({ page: 1, filters: _filters });
    setSelectedFilter(_filters);
  };

  const handleAssignBrandsToCompany = async (e) => {
    try {
      const payload = { company_id: Number(e.target.value) };

      if (selectedRowsData?.allSelected) {
        const isFilterApplied = Object.values(selectedFilter).flat().length;
        if (isFilterApplied) {
          payload.isFilterApplied = true
          payload.filters = selectedFilter
        }
        if (searchText) payload.query = searchText
      }
      payload.brands = selectedRowsData?.selectedRows?.map((c) => ({ id: c?.id }));

      await assignBrandToCompany(payload)
      _getTableData();
    } catch (e) {
      toast.error(e?.message || 'Something went wrong');
    }
  };

  const handleDelete = async () => {
    try {
      setDeleteLoading(true);
      const payload = {};

      if (selectedRowsData?.allSelected) {
        payload.brands = 'all'
        const isFilterApplied = Object.values(selectedFilter).flat().length;
        if (isFilterApplied) {
          payload.isFilterApplied = true
          payload.filters = selectedFilter
        }
        if (searchText) payload.query = searchText
      } else {
        payload.brands = selectedRowsData?.selectedRows?.length ? selectedRowsData?.selectedRows?.map((c) => ({ id: c?.id })) : [{ id: signleDeleteBrand }];
      }

      await deleteBrands(payload)
      _getTableData();
    } catch (e) {
      toast.error(e?.message || 'Something went wrong');
    } finally {
      setDeleteLoading(false);
      setConfirmationModal(false)
    }
  };

  const handleFetch = () => {
    const ids = selectedRowsData?.selectedRows?.map((row) => row?.id);
    if (!ids?.length) return;

    refetch({ type: 'brand', ids });
  };

  return (
    <div className='page-body'>
      <Breadcrumbs pageTitle='Brands' parent='Home' title='Brands Table' />
      <Container fluid>
        <Col sm={12}>
          <Card>
            <CardBody>
              <Row className="align-items-center justify-content-between">
                <Col xs="auto" className='d-flex flex-row gap-3 align-items-center flex-wrap'>
                  {selectedRowsData?.selectedCount > 0 && (
                    <>
                      <Input type="select" style={{ width: '150px' }} onChange={handleAssignBrandsToCompany}>
                        <option value={null}>Select</option>
                        {companies?.map((company) => (
                          <option key={company?.id} value={company?.id}>
                            {company?.name}
                          </option>
                        ))}
                      </Input>
                      <Button outline color='primary' onClick={() => setConfirmationModal(true)}><Trash /></Button>
                    </>
                  )}
                  <button style={{ border: 'none', outline: 'none', padding: '10px 15px', borderRadius: '7px' }} onClick={() => navigate(`/import-data/brand`)}>
                    + Import Brand
                  </button>
                  <button
                    style={{ border: 'none', outline: 'none', padding: '10px 15px', borderRadius: '7px', display: 'inline-flex', alignItems: 'center', gap: '6px' }}
                    onClick={handleExport}
                    disabled={exportLoading || !totalBrands}
                    title={`Export all ${totalBrands || 0} brands matching the current search and filters`}
                  >
                    {exportLoading ? <Spinner size="sm" /> : <Download size={16} />}
                    {exportLoading ? 'Exporting...' : 'Export Excel'}
                  </button>

                  <button onClick={() => setManuallModal(true)} style={{ border: 'none', outline: 'none', padding: '10px 15px', borderRadius: '7px', color: 'white', backgroundColor: 'black' }}>
                    Add Brand Manually
                  </button>
                  {selectedRowsData?.selectedCount > 0 && (
                    <button
                      onClick={handleFetch}
                      style={{ border: 'none', outline: 'none', padding: '10px 15px', borderRadius: '7px', color: 'white', backgroundColor: '#007bff' }}
                    >
                      Fetch
                    </button>
                  )}
                  {selectedRowsData?.selectedCount > 0 && (
                    <>
                      <button onClick={() => setBulkAddAction('matches')} style={{ border: 'none', outline: 'none', padding: '10px 15px', borderRadius: '7px', color: 'white', backgroundColor: '#007bff' }}>
                        Add to Matches
                      </button>
                      <button onClick={() => setBulkAddAction('next_to')} style={{ border: 'none', outline: 'none', padding: '10px 15px', borderRadius: '7px', color: 'white', backgroundColor: '#007bff' }}>
                        Add to Next To Brands
                      </button>
                    </>
                  )}
                </Col>
                <Col xs="auto" className='d-flex flex-row gap-3 align-items-center flex-wrap'>
                  <div className='d-flex flex-row gap-3 align-items-center'>
                    <Button outline onClick={() => setSpecificBrandsModalOpen(true)} style={{ position: 'relative', padding: '8px 12px', border: 'none' }}>
                      <Globe size={18} color={specificBrandsSearches.length ? 'black' : '#999'} />
                      <Search size={10} color={specificBrandsSearches.length ? 'black' : '#999'} style={{ position: 'absolute', bottom: '6px', right: '6px', backgroundColor: 'white', borderRadius: '50%' }} />
                    </Button>
                    <Input type="text" placeholder='Search name, domain or ID...' value={searchTerm} onChange={_handleSearchTextChange} />
                  </div>
                  <FilterDrawer data={filtersData} filters={selectedFilter} isLoading={filterLoading} onFilterApply={_handleFilterApply} />

                  <Dropdown isOpen={createdDatePickerOpen} toggle={() => setCreatedDatePickerOpen(!createdDatePickerOpen)}>
                    <DropdownToggle outline color="secondary" size="sm" style={{ borderRadius: '20px', padding: '8px 15px' }}>
                      <Calendar size={14} className="me-1" /> {formatDateRange(createdDateRange, 'Created')} <ChevronDown size={14} />
                    </DropdownToggle>
                    <DropdownMenu style={{ padding: '10px', minWidth: 'auto' }}>
                      <DatePicker
                        selected={createdDateRange?.startDate ? new Date(createdDateRange.startDate) : null}
                        onChange={handleCreatedDateChange}
                        startDate={createdDateRange?.startDate ? new Date(createdDateRange.startDate) : null}
                        endDate={createdDateRange?.endDate ? new Date(createdDateRange.endDate) : null}
                        selectsRange
                        inline
                        maxDate={new Date()}
                      />
                    </DropdownMenu>
                  </Dropdown>

                  <Dropdown isOpen={updatedDatePickerOpen} toggle={() => setUpdatedDatePickerOpen(!updatedDatePickerOpen)}>
                    <DropdownToggle outline color="secondary" size="sm" style={{ borderRadius: '20px', padding: '8px 15px' }}>
                      <Calendar size={14} className="me-1" /> {formatDateRange(updatedDateRange, 'Updated')} <ChevronDown size={14} />
                    </DropdownToggle>
                    <DropdownMenu style={{ padding: '10px', minWidth: 'auto' }}>
                      <DatePicker
                        selected={updatedDateRange?.startDate ? new Date(updatedDateRange.startDate) : null}
                        onChange={handleUpdatedDateChange}
                        startDate={updatedDateRange?.startDate ? new Date(updatedDateRange.startDate) : null}
                        endDate={updatedDateRange?.endDate ? new Date(updatedDateRange.endDate) : null}
                        selectsRange
                        inline
                        maxDate={new Date()}
                      />
                    </DropdownMenu>
                  </Dropdown>

                  {(createdDateRange?.startDate || updatedDateRange?.startDate) && (
                    <button type="button" className="btn btn-sm btn-outline-secondary" style={{ borderRadius: '20px' }} onClick={handleResetDateFilters}>
                      <X size={14} /> Reset Dates
                    </button>
                  )}
                </Col>
              </Row>
              <div className="table-responsive mt-3">
                <DataTable
                  striped
                  pagination
                  data={tableData}
                  className="display"
                  paginationServer
                  progressPending={isLoading}
                  paginationTotalRows={totalBrands}
                  paginationPerPage={itemsPerPage}
                  paginationDefaultPage={page}
                  selectableRows={true}
                  onSelectedRowsChange={setSelectedRowsData}
                  onRowClicked={(row) => setIsDrawerOpen(row)}
                  onChangePage={(newPage) => setPage(newPage)}
                  onChangeRowsPerPage={_handleItemPerPageSelect}
                  columns={[
                    {
                      name: "Profile",
                      sortable: false,
                      width: '180px',
                      cell: (row) => (
                        <div>
                          <Link target="_blank" to={`/profile/${row?.id}/brand`}>
                            <Eye size={20} color='#999' />
                          </Link>
                          <button className='btn' onClick={() => setEditNameModal(row)}>
                            <Edit size={20} color='#999' />
                          </button>
                          <button className='btn' onClick={() => {
                            setSignleDeleteBrand(row?.id)
                            setConfirmationModal(true)
                          }}><Trash size={20} color='#999' /></button>
                        </div>
                      ),
                      center: true,
                    },
                    {
                      name: 'Id',
                      selector: (row) => row?.id,
                      sortable: true,
                      center: false,
                      width: '120px',
                      cell: (row) => (
                        <span
                          onClick={(e) => handleCopyId(row?.id, e)}
                          style={{ cursor: 'pointer' }}
                          title="Click to copy"
                        >
                          {row?.id}
                        </span>
                      ),
                    },
                    {
                      name: "Brands",
                      cell: (row) => {
                        const tooltipId = `brand-tooltip-${row?.id}`;
                        return (
                          <>
                            <h6
                              id={tooltipId}
                              style={{
                                display: "-webkit-box",
                                overflow: "hidden",
                                WebkitBoxOrient: "vertical",
                                WebkitLineClamp: 2,
                              }}
                            >
                              {row?.name}
                            </h6>
                            <UncontrolledTooltip placement="top" target={tooltipId}>
                              {row?.name}
                            </UncontrolledTooltip>
                          </>
                        );
                      },
                      sortable: true,
                      center: false,
                    },
                    {
                      name: "Source",
                      cell: (row) => {
                        return row?.source ? (
                          <div>
                            <div
                              className="py-1 px-2 text-center"
                              style={{
                                fontWeight: 700,
                                color: "#1565C0",
                                borderRadius: '20px',
                                textWrap: 'nowrap',
                                backgroundColor: "#E3F2FD",
                              }}
                            >
                              {getCamelCaseWord(row?.source)}
                            </div>
                          </div>
                        ) : null;
                      },
                      sortable: false,
                      center: false,
                      width: '200px'
                    },
                    {
                      name: 'Website',
                      cell: (row) => {
                        const website = row.website;
                        return website ? (
                          <a
                            href={website.startsWith('http') ? website : `https://${website}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            title="Visit website"
                          >
                            <Globe size={20} color="#999" />
                          </a>
                        ) : (
                          <span>--</span>
                        );
                      },
                      sortable: false,
                      center: false,
                      minWidth: '200px',
                    },
                    {
                      name: "Created At",
                      selector: (row) => row?.created_at ? dayjs(row?.created_at).format("L") : "--",
                      sortable: true,
                      width: '180px',
                    },
                    {
                      name: "Updated At",
                      selector: (row) => row?.updated_at ? dayjs(row?.updated_at).format("L") : "--",
                      sortable: true,
                      width: '180px',
                    },
                    {
                      name: "Location",
                      cell: (row) => {
                        const tooltipId = `location-tooltip-${row?.id}`;

                        const value = row?.country || "N/A";

                        return (
                          <>
                            <div id={tooltipId}>{value}</div>
                            <UncontrolledTooltip placement="top" target={tooltipId}>
                              {value}
                            </UncontrolledTooltip>
                          </>
                        );
                      },
                      sortable: false,
                      center: false,
                    },
                    // {
                    //   name: "Preferred Market",
                    //   cell: (row) => {
                    //     const tooltipId = `pref-market-tooltip-${row?.id}`;
                    //     const value = row?.preferred_market?.[0] || "--";
                    //     return (
                    //       <>
                    //         <div id={tooltipId}>{value}</div>
                    //         <UncontrolledTooltip placement="top" target={tooltipId}>
                    //           {row?.preferred_market?.join(", ")}
                    //         </UncontrolledTooltip>
                    //       </>
                    //     );
                    //   },
                    //   sortable: false,
                    //   center: false,
                    // },
                    {
                      name: "Target Group",
                      cell: (row) => {
                        const tooltipId = `target-group-tooltip-${row?.id}`;
                        const value =
                          row?.main_target_group || row?.target_group?.length
                            ? row?.target_group[0]
                            : "--";
                        return (
                          <>
                            <div id={tooltipId}>{value}</div>
                            <UncontrolledTooltip placement="top" target={tooltipId}>
                              {row?.target_group?.join(", ")}
                            </UncontrolledTooltip>
                          </>
                        );
                      },
                      sortable: false,
                      center: false,
                    },
                    {
                      name: "Product Category",
                      cell: (row) => {
                        const tooltipId = `category-tooltip-${row?.id}`;
                        const value =
                          row?.main_category || row?.product_category?.length
                            ? row?.product_category[0]
                            : "--";
                        return (
                          <>
                            <div id={tooltipId}>{value}</div>
                            <UncontrolledTooltip placement="top" target={tooltipId}>
                              {row?.product_category?.join(", ")}
                            </UncontrolledTooltip>
                          </>
                        );
                      },
                      sortable: false,
                      center: false,
                    },
                    {
                      name: "Style",
                      cell: (row) => {
                        const tooltipId = `style-tooltip-${row?.id}`;
                        const value =
                          row?.main_style || row?.style?.length ? row?.style[0] : "--";
                        return (
                          <>
                            <div id={tooltipId}>{value}</div>
                            <UncontrolledTooltip placement="top" target={tooltipId}>
                              {row?.style?.join(", ")}
                            </UncontrolledTooltip>
                          </>
                        );
                      },
                      sortable: false,
                      center: false,
                    },
                    {
                      name: "Age group",
                      cell: (row) => {
                        const tooltipId = `age-tooltip-${row?.id}`;
                        const value = row?.main_age || "--";
                        return (
                          <>
                            <div id={tooltipId}>{value}</div>
                            <UncontrolledTooltip placement="top" target={tooltipId}>
                              {row?.age?.join(", ")}
                            </UncontrolledTooltip>
                          </>
                        );
                      },
                      sortable: false,
                      center: false,
                    },
                    {
                      name: "Price Range",
                      cell: (row) => {
                        const tooltipId = `price-tooltip-${row?.id}`;
                        const value = row?.price?.[0] || "--";
                        return (
                          <>
                            <div id={tooltipId}>{value}</div>
                            <UncontrolledTooltip placement="top" target={tooltipId}>
                              {row?.price?.join(", ")}
                            </UncontrolledTooltip>
                          </>
                        );
                      },
                      sortable: false,
                      center: false,
                    },

                    {
                      name: "Brand Rating",
                      cell: (row) => `${Math.ceil(row?.brand_rating) || "--"}`,
                      sortable: false,
                      center: true,
                    },
                    {
                      name: "Brand Rating (+2)",
                      cell: (row) => `${Math.ceil(row?.brand_rating_upgrade) || "--"}`,
                      sortable: false,
                      center: true,
                      width: '180px',
                    },
                    {
                      name: "Price Point",
                      cell: (row) => `${row?.price_point || "--"}`,
                      sortable: false,
                      center: false,
                    },

                  ]}
                  expandableRows={true}
                  expandableRowsComponent={BrandExpandedTableRow}
                />
              </div>
            </CardBody>
          </Card>
        </Col>
      </Container>
      <AddManuallyModal type='brand' open={manuallyModal} onClose={() => setManuallModal(false)} onSuccess={_getTableData} />
      {bulkAddAction && (
        <BulkAddToProfileModal
          type='brand'
          action={bulkAddAction}
          selectedIds={selectedRowsData?.selectedRows?.map((row) => row?.id) || []}
          onClose={() => setBulkAddAction(null)}
        />
      )}
      <CompaniesDrawer isOpen={Boolean(openDrawer)} type='brand' onSuccess={_getTableData} entity={openDrawer} onClose={() => setOpenDrawer(false)} />
      <BrandsDetailsDrawer isOpen={Boolean(isDrawerOpen)} brand={isDrawerOpen} onClose={() => setIsDrawerOpen(false)} />
      <EditEntityNameModal
        type='brand'
        name={editNameModal?.name}
        entityId={editNameModal?.id}
        open={Boolean(editNameModal)}
        onClose={() => setEditNameModal(null)}
        onSuccess={_getTableData}
      />
      <ConfirmationModal open={confirmationModal} onClose={() => setConfirmationModal(false)} onSubmit={handleDelete} isLoading={deleteLoading} />
      <SpecificBrandsSearchModal 
        isOpen={specificBrandsModalOpen} 
        toggle={() => setSpecificBrandsModalOpen(!specificBrandsModalOpen)} 
        onSearch={handleSpecificBrandsSearch} 
      />
    </div>
  )
}

const CompanyDropDownSelect = ({ row, onRowClicked }) => {
  return (
    <div className='d-flex align-items-center flex-wrap gap-2'>
      <h6 style={{ color: row?.company?.length ? '#1ca814' : '#e0210b' }}>{row?.company?.length ? 'Assigned' : 'Un-assigned'}</h6>
      <button onClick={onRowClicked} className='btn'>
        <FiExternalLink size={18} />
      </button>
    </div>
  );
};

const mapStateToProps = (state) => ({
  allBrands: state.brands.allBrands,
  filtersData: state.brands?.filters,
  totalBrands: state.brands.totalBrands,
  selectedFilters: state.brands?.selectedFilters,
});

const mapDispatchToProps = {
  getFilters: getFiltersAction,
  getAllBrands: getAllBrandsAction,
  getCompanies: getCompaniesAction,
  deleteBrands: deleteBrandsAction,
  assignBrandToCompany: assignBrandToCompanyAction,
  setSelectedFilters: setSelectedFiltersAction,
  refetch: refetchAction,
  exportBrands: exportBrandsAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(Brands);
